import { render, staticRenderFns } from "./StatementReview.vue?vue&type=template&id=e1c1ffb0"
import script from "./StatementReview.vue?vue&type=script&lang=js"
export * from "./StatementReview.vue?vue&type=script&lang=js"
import style0 from "./StatementReview.vue?vue&type=style&index=0&id=e1c1ffb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports